module.exports = __webpack_public_path__ + "img/tron (39).fa00f8fc.jpg";